import React, { useContext, useState } from "react";
import { APIContext } from "../../api";
import { ProjectDataContext } from "../../context/projectContext";

export default function ProjectDemoMode({ projectID }) {
  const { setProjectDemoMode } = useContext(APIContext);
  const { projectData, setProjectData } = useContext(ProjectDataContext);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const enabled = projectData.dashboardDemoMode === true;

  async function toggle() {
    if (saving) return;
    setSaving(true);
    setError("");
    try {
      const result = await setProjectDemoMode(projectID, !enabled);
      setProjectData((current) => ({
        ...current,
        dashboardDemoMode: result.enabled,
      }));
    } catch (err) {
      setError(
        err?.response?.data?.message || "Could not save demo mode. Try again."
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <section
      className="w-full rounded-xl border border-purple-200 bg-purple-50/50 p-4 mb-6"
      aria-label="Project demo data"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="font-semibold text-slate-900">Demo data</h2>
          <p className="mt-1 text-sm text-slate-600">
            Show sample leads, products, orders, subscribers, newsletter
            results, and analytics when this project is opened.
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Reopen or refresh the project after changing this setting. Turning
            it off restores real data. Demo screens are read-only.
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-label="Demo data"
          aria-checked={enabled}
          disabled={saving}
          onClick={toggle}
          className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold disabled:opacity-50 ${
            enabled
              ? "bg-[#623ce7] text-white"
              : "border border-slate-300 bg-white text-slate-700"
          }`}
        >
          {saving ? "Saving…" : enabled ? "On" : "Off"}
        </button>
      </div>
      {error && (
        <p role="alert" className="mt-2 text-sm text-red-700">
          {error}
        </p>
      )}
    </section>
  );
}
